import { XMarkIcon } from "@heroicons/react/24/outline";
import "./Modals.css";
import SimpleCombobox from "../../components/SimpleCombobox";
import { useState } from "react";
import api from "../../api";

export const ModalAlert = (props) => {
    const closeDialog = () => {
        props.dialogRef.current?.close();
    };

    return (
        <div
            className={`alert overflow-auto ${
                props.type === "stock" && "orange"
            } ${props.type === "expiration" && "red"}`}
        >
            <div className="flex justify-between items-center">
                <h2 className="text-gray-800 text-2xl font-bold">
                    {props.title}
                </h2>
                <button
                    className="hover:bg-white hover:bg-opacity-50 p-1 rounded transition-all"
                    onClick={closeDialog}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            {props.subTitle && <h4 className="font-bold">{props.subTitle}</h4>}
            {props.list && (
                <ul className="mt-4">
                    {props.list.map((item, index) => (
                        //cambiar la key por algo de la repuesta
                        <li
                            key={`${index}-${item.supply}`}
                            className="flex mt-3 pb-2 justify-between border-b border-b-black"
                        >
                            <span>{item.supply}</span>
                            <span>{item.stock || item.expiration}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export const NewSupplieForm = (props) => {
    const [newSupplie, setNewSupplie] = useState({
        category: null,
        minStock: null,
        expirationDate: "",
        stock: null,
        unitCost: null,
        brand: null,
    });
    const [formErrors, setFormErrors] = useState({
        category: false,
        minStock: false,
        expirationDate: false,
        stock: false,
        unitCost: false,
        brand: false,
    });
    const closeDialog = () => {
        props.dialogRef.current?.close();
    };

    const handleChange = (field, value) => {
        const parsedValue =
            typeof value === "object" && value !== null ? value.name : value;
        setNewSupplie((prev) => ({
            ...prev,
            [field]: parsedValue,
        }));
        setFormErrors({ ...formErrors, [field]: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const newErrors = {
            category: !newSupplie.category && "Este campo es obligatorio",
            minStock: !newSupplie.minStock && "Este campo es obligatorio",
            expirationDate:
                newSupplie.expirationDate.trim() === "" &&
                "Este campo es obligatorio",
            stock: !newSupplie.stock && "Este campo es obligatorio",
            unitCost: !newSupplie.unitCost && "Este campo es obligatorio",
            brand: !newSupplie.brand && "Este campo es obligatorio",
        };
        setFormErrors(newErrors);
        const hasErrors = Object.values(newErrors).some((e) => e);
        if (hasErrors) return;

        try {
            const response = await api.supplies.create(newSupplie);

            props.setSupplies((prev) => [...prev, response]);
            props.dialogRef.current?.close();
        } catch (error) {
            console.error("Error al agerar el nuevo insumo:", error);
            alert("Hubo un error al guardar el insumo. Inténtalo nuevamente.");
        }
    };

    const createCategory = async (newItem) => {
        const response = await api.categories.create(newItem);
        props.setCategories((prev) => [...prev, response]);
        return response;
    };

    const createBrand = async (newItem) => {
        const response = await api.brands.create(newItem);
        props.setBrands((prev) => [...prev, response]);
        return response;
    };

    return (
        <form className={`alert`} onSubmit={handleSubmit}>
            <div className="flex justify-between items-center">
                <h2 className="text-gray-800 text-2xl font-bold">
                    Nuevo Insumo
                </h2>
                <button
                    type="button"
                    className="hover:bg-black hover:bg-opacity-10 p-1 rounded transition-all"
                    onClick={closeDialog}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            <div className="modal-input-grid mt-5">
                <SimpleCombobox
                    inputClassName="relative"
                    placeholder={"Escribe el nombre..."}
                    handleChange={handleChange}
                    name="category"
                    label="Nombre del insumo"
                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                    options={props.categories}
                    create={createCategory}
                    required={true}
                    error={formErrors.category}
                />
                <div>
                    <label
                        htmlFor="minStock"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Stock mínimo
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="Escribe el stock minimo..."
                        name="minStock"
                        id="minStock"
                        value={newSupplie.minStock}
                        onChange={(e) =>
                            handleChange("minStock", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.minStock
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.minStock && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.minStock}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="expirationDate"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Fecha de vencimiento
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="date"
                        name="expirationDate"
                        id="expirationDate"
                        value={newSupplie.expirationDate}
                        onChange={(e) =>
                            handleChange("expirationDate", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.expirationDate
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.expirationDate && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.expirationDate}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="stock"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Stock actual
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="Escribe el stock actual..."
                        name="stock"
                        id="stock"
                        value={newSupplie.stock}
                        onChange={(e) => handleChange("stock", e.target.value)}
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.stock
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.stock && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.stock}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="unitCost"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Costo unitario
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        step="any"
                        placeholder="Escribe el consto por unidad..."
                        name="unitCost"
                        id="unitCost"
                        value={newSupplie.unitCost}
                        onChange={(e) =>
                            handleChange("unitCost", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.unitCost
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.unitCost && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.unitCost}
                        </p>
                    )}
                </div>
                <SimpleCombobox
                    inputClassName="relative"
                    placeholder={"Seleccione la marca"}
                    handleChange={handleChange}
                    name="brand"
                    label="Marca"
                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                    options={props.brands}
                    create={createBrand}
                    required={true}
                    error={formErrors.brand}
                />
            </div>
            <button
                type="submit"
                className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary"
            >
                Agregar insumo
            </button>
        </form>
    );
};
